// src/hooks/useResourceTypes.js
import { useState, useEffect } from 'react';
import { API_ENDPOINTS, apiRequest } from '../config/api';

// Cache key for localStorage
const CACHE_KEY = 'resource_types_cache';
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour

const useResourceTypes = () => {
  const [resourceTypes, setResourceTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResourceTypes = async () => {
      try {
        setIsLoading(true);
        // Check cache first
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
          const { data, timestamp } = JSON.parse(cachedData);
          if (Date.now() - timestamp < CACHE_DURATION) {
            setResourceTypes(data);
            setIsLoading(false);
            return;
          }
        }
        const data = await apiRequest(API_ENDPOINTS.TYPES.BASE);
        // Update cache
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          data,
          timestamp: Date.now()
        }));
        setResourceTypes(data);
      } catch (err) {
        console.error('Error fetching resource types:', err);
        setError(err.message);
        // If there's an error but we have cached data, use that
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
          const { data } = JSON.parse(cachedData);
          setResourceTypes(data);
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchResourceTypes();
  }, []);

  return { resourceTypes, isLoading, error };
};

export default useResourceTypes;